import { render, staticRenderFns } from "./user-new.vue?vue&type=template&id=b1c7f93e&scoped=true&"
import script from "./user-new.vue?vue&type=script&lang=js&"
export * from "./user-new.vue?vue&type=script&lang=js&"
import style0 from "./user-new.vue?vue&type=style&index=0&id=b1c7f93e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c7f93e",
  null
  
)

export default component.exports